// extracted by mini-css-extract-plugin
export default {"itemRow":"ItemRow_itemRow__YCM5v"};